import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Typography } from '@mui/material';
import { selectedUserIdSelector } from '../../../../selectors/userSelectors';
import { useCreateImpersonationLinkMutation, useGetUserInfoQuery } from '../../../../api/userApi';

const ImpersonationSection = () => {
  const selectedUserId = useSelector(selectedUserIdSelector);
  const { data: userInfo, isLoading: isUserInfoLoading } = useGetUserInfoQuery(selectedUserId);

  const [createImpersonationLink] = useCreateImpersonationLinkMutation();

  if (isUserInfoLoading) {
    return null;
  }

  const impersonateUser = async () => {
    createImpersonationLink(userInfo.id);
  };

  return (
    <Box sx={{ textAlign: 'right' }}>
      <Button
        variant='contained'
        fullWidth
        sx={{ height: 50, borderRadius: 30, background: '#999999' }}
        onClick={impersonateUser}>
        <Typography variant='body2'>Open Portal</Typography>
      </Button>
    </Box>
  );
};

export default ImpersonationSection;
